<template>
  <div
    class="SpaceHandler"
    :class="[spacingClasses, backgroundColor]"
  >
    <div
      ref="observerEl"
      :class="[fadeIn]"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * It seems we can't type this since storyblok thinks it's an SbDataBlok
 */
const props = defineProps<{
  blok: any,
}>();

const route = useRoute();
const isInStoryblokAdmin = (route.query && route.query._storyblok && route.query._storyblok !== '');

const spacingClasses = computed(() => {
  const output = [];
  if (props.blok?.visualAppearance?.spacing) {
    output.push(props.blok.visualAppearance.spacing);
  } else {
    output.push('spacing-base');
  }
  return output;
});

const backgroundColor = computed(() => {
  const output = [];
  if (props.blok?.visualAppearance?.backgroundColor) {
    output.push(props.blok.visualAppearance.backgroundColor);
  } else {
    output.push('bg-base');
  }
  return output;
});

const fadeIn = computed(() => {
  const output = [];
  if (!isInStoryblokAdmin && props.blok?.visualAppearance?.fade_type?.length) {
    output.push(props.blok?.visualAppearance?.fade_type.replaceAll('_', '-'));
  }
  return output;
});

const observerEl = ref(null);

onMounted(() => {
  if (observerEl.value && !isInStoryblokAdmin && props.blok?.visualAppearance?.fade_type?.length) {
    const observerOptions = {
      root: null,
      threshold: 0,
      rootMargin: '-100px',
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('observer-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    observer.observe(observerEl.value as unknown as Element);
    onBeforeUnmount(() => {
      observer.unobserve(observerEl.value as unknown as Element);
    });
  }
});

</script>

<style scoped lang="postcss">
</style>
